import React, { useEffect, useState } from "react"
import SignatureModal from "./components/SignatureModal"
import { useDispatch, useSelector } from "react-redux"

import ContractDetails from "./components/ContractDetails"
import RejectContractModal from "./components/RejectContractModal"

import { getMyContract } from "store/actions/contractsAction"

const CandidatesContract = () => {
  const [showSignaturePad, setShowSignaturePad] = useState(false)
  const [showRejectionModal, setShowRejectionModal] = useState(false)
  const [trigger, setTrigger] = useState(false)

  const dispatch = useDispatch()
  const { myContract } = useSelector(state => state.Contract)

  useEffect(() => {
    dispatch(getMyContract())
  }, [trigger])

  return (
    <div className="page-content">
      <ContractDetails
        data={myContract}
        onAccept={() => setShowSignaturePad(true)}
        onReject={() => setShowRejectionModal(true)}
      />
      {showSignaturePad && (
        <SignatureModal
          isOpen={showSignaturePad}
          toggleModal={() => setShowSignaturePad(!showSignaturePad)}
          trigger={() => setTrigger(!trigger)}
        />
      )}
      {showRejectionModal && (
        <RejectContractModal
          isOpen={showRejectionModal}
          toggle={() => setShowRejectionModal(!showRejectionModal)}
          trigger={() => setTrigger(!trigger)}
        />
      )}
    </div>
  )
}

export default CandidatesContract
